var isNewIOSApp = () => {
  var _a, _b;
  return typeof (window === null || window === void 0 ? void 0 : window.webkit) !== 'undefined' && Boolean((_b = (_a = window === null || window === void 0 ? void 0 : window.webkit) === null || _a === void 0 ? void 0 : _a.messageHandlers) === null || _b === void 0 ? void 0 : _b.triggerAppEvent);
};
var hasMyAirtelAppReactObj = () => typeof (window === null || window === void 0 ? void 0 : window.MyAirtelAppReact) !== 'undefined';
var isNewThanksApp = () => typeof (window === null || window === void 0 ? void 0 : window.ReactNativeWebView) !== 'undefined';
var isThanksApp = () => isNewThanksApp() || hasMyAirtelAppReactObj() || isNewIOSApp();
export var getPlatform = isLargeScreen => {
  var platform = 'mweb';
  if (isNewIOSApp()) {
    platform = 'ios-webview';
  } else if (isThanksApp()) {
    platform = 'android-webview';
  } else if (isLargeScreen) {
    platform = 'dweb';
  }
  return platform;
};